import { SummernoteDirective } from './../../shared/forms/editors/summernote.directive';
import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { NotificationService } from '../../shared/utils/notification.service';
import { AssetEmailDto } from 'app/client-core/dtos/asset-email.model';
import { TacticService } from 'app/client-core/services/tactic.service';
import { ValidationMessage } from 'app/validation';
import { SummernoteAttachDirective } from 'app/shared/forms/editors/summernote-attach.directive';
import { TacticAssetslistItemDTO } from 'app/client-core/dtos/tactics.model';
import { UserDto } from 'app/client-core/dtos/users.model';
import { UserService } from 'app/client-core/services/user.service';
import { ProgramService } from 'app/client-core/services/program.service';

const $ = jQuery;
@Component({
    selector: 'asset-email-modal',
    templateUrl: './asset-email.modal.component.html',
    styleUrls: [
        './asset-email.scss'
    ]
})
export class ProgramEmailModalComponent implements OnInit {
    ready: boolean;
    dto: {
        programId: number,
        users: string,
        type: string,
        message: string
    } = {
        programId: null,
        message: '',
        type: '',
        users: ''
    };

    @Input() programId: number;
    additionalColumns = [
        { prop: 'item.email', name: 'Email', minWidth: 150 }
    ]
    users: Array<any> = [];
    types = [
        {
            title: 'Action Requested'
        },
        {
            title: 'General Information'
        }
    ]

    submitted: boolean;
    public validationMessages: ValidationMessage;

    constructor(
        public modalRef: BsModalRef,
        private notificationService: NotificationService,
        private programService: ProgramService,
        private userService: UserService
    ) {
    }

    ngOnInit() {
        this.ready = true;
        // this.dto.additionalBody = `<a href="${this.downloadURL}">${this.downloadURL}</a>`;
    }

    close(): void {
        this.modalRef.hide();
    }

    sendEmail() {
        this.submitted = false;
        this.dto.message = $('.note-editable').html();
        if (!this.canSubmit()) {
            this.submitted = true;
            this.validationMessages = new ValidationMessage(null, true, 'There were some validation erros').isDanger();
            return;
        }
        this.dto.users = this.users.map(u => {
            return u.id
        }).join(',');
        this.dto.programId = this.programId;
        this.programService.sendMessage(this.dto).subscribe(response => {
            this.validationMessages = new ValidationMessage(null, true, 'Message sent').isSuccess();
            this.close();
        });
    }

    canSubmit() {
        return this.isUserValid() &&
        this.dto.message &&
        this.isBodySizeValid() &&
        this.isTypeValid();
    }

    onUserSelected(event) {
        if (!this.users.find(u => u.id == event.item.id)) {
            this.users.push(event.item);
        }
    }

    removeUser(item) {
        if (this.users.find(u => u.id == item.id)) {
            this.users = this.users.filter(u => u.id != item.id);
        }
    }

    isUserValid() {
        return this.users && this.users.length > 0;
    }

    isTypeValid() {
        if (!this.dto.type) {
            return false;
        }
        return true;
    }

    isBodySizeValid() {
        if (!this.dto.message) {
            return false;
        }
        return this.dto.message.length < 5000;
    }
}





// WEBPACK FOOTER //
// ./src/app/+campaign-library/email-modal/asset-email.modal.component.ts